import React from 'react';
import UserButton from './UserButton';
import { full_name } from './utilities'

const EmployeesList = (props) => {

    const { employees, clients, employeesSize, user } = props;

    return (
        <article className="employee-list">
            <header>
                <div className="title">
                    ユーザ一覧 <span className="badge badge-light ml-2">
                        {employeesSize}
                    </span>
                </div>
            </header>

            <header>
                <div className="employee-id">
                    ID
                </div>
                <div className="employee-ful-name">
                    氏名
                </div>
                <div className="employee-staff-code">
                    スタッフコード
                </div>
                <div className="employee-enrollment-status">
                    雇用形態
                </div>
                <div className="user-controls">
                    操作
                </div>
            </header>

            {employees.map(employee => {
                return (
                    <section key={employee.id}>
                        <div className="employee-id">
                            {employee.id}
                        </div>
                        <div className="employee-full-name">
                            <a className="btn btn-light btn-sm" href={`/desk/clients/${clients.id}/employees/${employee.id}`}>{full_name(employee.firstName,employee.lastName)}</a>
                        </div>
                        <div className="employee-staff-code">
                            {employee.staffCode}
                        </div>
                        <div className="employee-enrollment-status">
                            {employee.enrollmentStatus}
                        </div>
                        <div className="user-controls d-flex flex-row-reverse">
                            <a className="btn btn-primary ml-2" href={`/desk/clients/${clients.id}/employees/${employee.id}`}>表示</a>
                            <UserButton user={user} clients={clients}/>
                        </div>
                        
                    </section>
                )   
            })}
        </article>
    )
}

export default EmployeesList
